import { cn } from '../lib/cn.ts';

/** Инициалы: «Анна Нечаева» → «АН». */
export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const letters = parts.length >= 2 ? [parts[0], parts[1]] : [parts[0]];
  return letters
    .map((p) => (p ?? '').charAt(0))
    .join('')
    .toUpperCase();
}

const SIZES = { sm: 'size-5 text-[0.5625rem]', md: 'size-7 text-caption', lg: 'size-10 text-small' } as const;

export function Avatar({
  name,
  src,
  size = 'md',
  className,
}: {
  name: string;
  src?: string | null;
  size?: keyof typeof SIZES;
  className?: string;
}) {
  return (
    <span
      className={cn(
        // Круг всегда тёмный с инициалами цвета акцента; в тёмной теме — чуть светлее фона и с обводкой.
        'inline-grid shrink-0 place-items-center overflow-hidden rounded-full bg-ink font-bold text-accent',
        'ring-1 ring-ink-ring',
        SIZES[size],
        className,
      )}
      title={name}
    >
      {src ? <img src={src} alt={name} className="size-full object-cover" /> : initials(name)}
    </span>
  );
}
